// extracted by mini-css-extract-plugin
export default {"productsSwiper":"productsSlider_productsSwiper__OGBtB","products":"productsSlider_products__2wi8S"};